import { BaseModel, convertToArrayModels, fillOwnProperties, registerModel } from '~/shared/model'
import { isUnknownObject } from '~/shared/utils/guards'

export type UniversityFilterBlockType =
  | 'collapsible'
  | 'selector'
  | 'multi-selector'
  | 'slider'
  | 'checkbox'
  | 'total'
  | 'search'

export interface UniversityFilterOption {
  name: string
}

export default class UniversityFilterBlock extends BaseModel {
  static override constructorName = 'UniversityFilterBlock'

  id: string = ''
  name: string = ''
  type: UniversityFilterBlockType = 'checkbox'
  placeholder: string = ''
  value: boolean | string | UniversityFilterOption[] = ''
  count?: number
  options: UniversityFilterOption[] = []
  min?: number
  max?: number
  step?: number
  items: UniversityFilterBlock[] = []
  cleared: boolean = true

  constructor(data?: unknown) {
    super(data)
    if (isUnknownObject(data)) {
      fillOwnProperties(this, data)

      this.items = convertToArrayModels(data.items, UniversityFilterBlock)
    }
  }
}

registerModel(UniversityFilterBlock)
